"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWalletTokenBalances = void 0;
var evm_utils_1 = require("@moralisweb3/evm-utils");
var api_utils_1 = require("@moralisweb3/api-utils");
var EvmChainResolver_1 = require("../EvmChainResolver");
exports.getWalletTokenBalances = (0, api_utils_1.createEndpointFactory)(function (core) {
    return (0, api_utils_1.createEndpoint)({
        name: 'getWalletTokenBalances',
        urlParams: ['address'],
        getUrl: function (params) { return "/".concat(params.address, "/erc20"); },
        apiToResult: function (data, params) {
            return (data !== null && data !== void 0 ? data : []).map(function (token) {
                return evm_utils_1.Erc20Value.create(token.balance, {
                    decimals: token.decimals,
                    token: {
                        decimals: token.decimals,
                        name: token.name,
                        symbol: token.symbol,
                        contractAddress: token.token_address,
                        logo: token.logo,
                        thumbnail: token.thumbnail,
                        chain: EvmChainResolver_1.EvmChainResolver.resolve(params.chain, core),
                    },
                });
            });
        },
        resultToJson: function (data) { return data.map(function (tokenValue) { return tokenValue.toJSON(); }); },
        parseParams: function (params) { return ({
            to_block: params.toBlock,
            token_addresses: params.tokenAddresses,
            chain: EvmChainResolver_1.EvmChainResolver.resolve(params.chain, core).apiHex,
            address: evm_utils_1.EvmAddress.create(params.address, core).lowercase,
        }); },
    });
});
